import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { usePromptFragments } from "../hooks";

export const PromptFragmentsList: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = usePromptFragments();

  return (
    <>
      <Header
        title="Fragments de prompt"
        subtitle="Ajustements optionnels combinables avec un thème de base"
        buttons={[
          {
            actionText: "Nouveau fragment",
            bgColor: "indigo",
            textColor: "white",
            link: `/prompt-fragment/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.promptFragments?.results?.length ? (
            <EmptyList text="Aucun fragment" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Code</TableCell>
                  <TableCell header>Nom</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.promptFragments?.results?.map((fragment) => (
                  <TableRow
                    key={`prompt-fragment-${fragment.id}`}
                    onClick={() => navigate(`/prompt-fragment/${fragment.id}/update`)}
                  >
                    <TableCell>{fragment.code}</TableCell>
                    <TableCell>{fragment.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
